import { render, staticRenderFns } from "./Compare.vue?vue&type=template&id=1898dac3&scoped=true&"
import script from "./Compare.vue?vue&type=script&setup=true&lang=ts&"
export * from "./Compare.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./Compare.vue?vue&type=style&index=0&id=1898dac3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1898dac3",
  null
  
)

export default component.exports